<div class="mx-auto min-h-[526px] bg-white rounded-[20px] p-8">
  <div class="relative">
    <button
      type="button"
      (click)="goBack()"
      [ngClass]="{ 'flex items-center gap-2 text-tw-text-color': true }"
    >
      <svg-icon
        src="assets/svgs/arrow-left-alt.svg"
        [svgStyle]="{ 'width.px': 16, 'height.px': 16 }"
      ></svg-icon>
      <span class="text-sm font-medium">Go back</span>
    </button>
  </div>
  <!-- Title Section -->
  <div class="w-full">
    <div class="relative flex justify-center w-full pb-8 text-center">
      <img
        [src]="'assets/images/icon-logo.png'"
        class="w-[50px] overflow-hidden object-fill"
      />
    </div>

    <div [ngClass]="{ 'flex flex-col items-center pb-8': true }">
      <h3 [ngClass]="{ 'text-[#292929] text-2xl font-bold': true }">
        Sign into your account
      </h3>
      <p [ngClass]="{ 'text-tw-text-color text-base': true }">
        Please provide Accurate information to your account
      </p>
    </div>
  </div>

  <form
    [formGroup]="authForm"
    (ngSubmit)="onSubmit()"
    class="flex flex-col flex-1 w-full p-4"
  >
    <div class="flex flex-col gap-6 pb-4">
      <div class="w-full mx-auto">
        <label for="" class="flex flex-col">
          <div class="relative flex w-full">
            <!-- <input appGeneralInput type='email' placeholder="Enter email" formControlName="email" /> -->
            <app-general-input
              label="Email"
              type="email"
              placeholder="Enter email"
              controlName="email"
              [formGroup]="authForm"
            ></app-general-input>

            <div
              *ngIf="
                !!authForm.get('email')?.errors &&
                authForm.get('email')?.touched
              "
              class="absolute top-[calc(100%+1px)] text-[12px] pl-[5px] text-[#EB5757] flex items-center gap-[4px]"
            >
              <span *ngIf="authForm.get('email')?.errors?.email">{{
                "Invalid email"
              }}</span>
              <span *ngIf="authForm.get('email')?.errors?.required"
                >Field is required</span
              >
            </div>
          </div>
        </label>
      </div>
      <div class="w-full mx-auto">
        <label for="" class="flex flex-col">
          <div class="relative flex w-full">
            <app-password-input
              label="Password"
              placeholder="Enter password"
              controlName="password"
              [formGroup]="authForm"
            ></app-password-input>

            <div
              class="absolute top-[calc(100%+1px)] text-[12px] pl-[5px] text-[#EB5757] flex items-center gap-[4px]"
              *ngIf="
                !!authForm.get('password')?.errors &&
                authForm.get('password')?.touched
              "
            >
              <span *ngIf="authForm.get('password')?.errors?.required"
                >Field is required</span
              >
            </div>
          </div>
        </label>
      </div>
      <div [ngClass]="{ 'text-center pt-4': true }">
        <a
          href=""
          class="text-sm leading-6 underline text-[#226449] underline-offset-[3px] text-center font-bold"
          [routerLink]="[]"
          routerLinkActive="bg-slate-200"
          [routerLinkActiveOptions]="{ exact: true }"
          [queryParams]="{ a: 'forgot-password' }"
          >Forgot password</a
        >
      </div>
    </div>
    <div class="mt-auto text-center">
      <button
        nz-button
        nzType="primary"
        nzSize="large"
        nzShape="round"
        type="submit"
        class="w-full"
        [disabled]="mutation.isPending()"
        [nzLoading]="mutation.isPending()"
      >
        Sign In
      </button>
    </div>
  </form>
  <div
    class="flex items-center justify-center gap-2 py-8 text-center login-notice"
  >
    <p
      [ngClass]="{
        'text-tw-text-color font-normal text-base capitalize': true,
      }"
    >
      Don&apos;t have an account?
    </p>
    <button
      [ngClass]="{ 'text-[#226449] text-base underline font-bold': true }"
      (click)="switchToRegister()"
    >
      Register
    </button>
  </div>
</div>
